import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const ContactScorpionForm = forwardRef(({contact, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={contact}
      type="contact"
      fieldsComponent={(props) => <Fields {...props}/>}
      onSave={({scorpion_customer, scorpion_user, scorpion_brand}) => services.contact.saveContact({
        id: contact.id,
        scorpion_customer,
        scorpion_user,
        scorpion_brand,
      })}
      onSaved={onSaved}
    />
  );
});

export default ContactScorpionForm;
